"use strict";
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.looseMatch = void 0;
/**
 * Checks whether two strings match, ignoring punctuation, spaces and case.
 * E.g. "truePosition" would match "true position" or "TRUE_POSITION".
 */
const looseMatch = (a, b) => {
    if (typeof a !== "string" && typeof b !== "string")
        return true;
    if (typeof a !== "string" || typeof b !== "string")
        return false;
    const nonWord = /[-_\W]+/g;
    return (a.replace(nonWord, "").toLowerCase() ===
        b.replace(nonWord, "").toLowerCase());
};
exports.looseMatch = looseMatch;
//# sourceMappingURL=index.js.map